import * as React from 'react'

import { LOCIZE_NAMESPACE as NAMESPACE } from 'main/common'
import { palette, ProgramClosedIcon, ProgramEnrollingIcon, ProgramNotEnrollingIcon } from 'main/ui'
import { UnreachableCaseError } from 'main/util/ts'
import { CheckCircle } from 'react-feather'
import { useTranslation } from 'react-i18next'
import { i18nKeyPrefix } from '../../../i18n'
import {
  BadgeContainer,
  BadgeIconContainer,
  BadgeSubContainer,
  BadgeSubText,
  BadgeText,
  BadgeTextContainer,
  OpenBadgeContainer,
} from '../../common.styles'
import { CovidStatus } from './types'
interface IProps {
  status: CovidStatus
  ageRangeText?: string | null
  textAvailability?: string | null
}

const PRE = `${i18nKeyPrefix}-BADGE`

export default function Status(props: IProps) {
  const { status, ageRangeText, textAvailability } = props
  const { t, i18n } = useTranslation(NAMESPACE)

  const content = React.useMemo(() => {
    const enrolling = t(`${PRE}-ENROLLING`)
    const notEnrolling = t(`${PRE}-NOT-ENROLLING`)
    const closed = t(`${PRE}-CLOSED`)

    const openAvailableDescription = t(`${PRE}-OPEN-AVAILABLE-DESCRIPTION`)
    const closeTitle = t(`${PRE}-CLOSE-TITLE`)
    return {
      enrolling,
      notEnrolling,
      closed,
      openAvailableDescription,
      closeTitle,
    }
  }, [i18n.resolvedLanguage])

  return renderContent()

  function renderContent() {
    switch (status) {
      case CovidStatus.OPEN_ENROLLING:
        return (
          <OpenBadgeContainer>
            <BadgeContainer style={{ backgroundColor: palette.cosmicLatte }}>
              <BadgeIconContainer>
                <ProgramEnrollingIcon size="small" />
              </BadgeIconContainer>
              <BadgeTextContainer>
                <BadgeText>
                  {content.enrolling}: {ageRangeText}
                </BadgeText>
              </BadgeTextContainer>
            </BadgeContainer>
            {textAvailability && (
              <BadgeSubContainer>
                <CheckCircle color={palette.fern2} size="24px" />
                <BadgeTextContainer>
                  <BadgeSubText>{textAvailability}</BadgeSubText>
                </BadgeTextContainer>
              </BadgeSubContainer>
            )}
          </OpenBadgeContainer>
        )
      case CovidStatus.OPEN_FULL:
        return (
          <BadgeContainer>
            <BadgeIconContainer>
              <ProgramNotEnrollingIcon size="small" />
            </BadgeIconContainer>
            <BadgeTextContainer>
              <BadgeText>{content.notEnrolling}</BadgeText>
            </BadgeTextContainer>
          </BadgeContainer>
        )
      case CovidStatus.CLOSED:
        return (
          <BadgeContainer>
            <BadgeIconContainer>
              <ProgramClosedIcon size="small" />
            </BadgeIconContainer>
            <BadgeTextContainer>
              <BadgeText>{content.closed}</BadgeText>
            </BadgeTextContainer>
          </BadgeContainer>
        )
      default:
        throw new UnreachableCaseError(status)
    }
  }
}
